/**
 * LogoGlint — premium white-streak animation overlay for the NoJo N.
 *
 * Behaviour:
 *   - Page-load: a quick double-pass glint runs after a 0.6s settle delay.
 *   - Then every 120 seconds: another double-pass.
 *   - The streak is a thin white linear-gradient diagonal band that
 *     translates across the logo's bounding box.
 *   - Honours prefers-reduced-motion (no animation at all).
 *   - Pure CSS — no JS animation loop, no setInterval, no perf cost on
 *     mobile.
 *
 * Drop this component INSIDE the logo wrapper. Caller controls the
 * wrapper's position (relative). The glint is absolutely positioned and
 * pointer-events: none.
 */
export default function LogoGlint({ size = "header", className = "" }) {
  // Streak width scales with logo size so it reads correctly at all scales.
  const widthByVariant = {
    header: 22,
    footer: 28,
    hero: 46,
    huge: 64,
  };
  const w = widthByVariant[size] || widthByVariant.header;
  return (
    <span
      aria-hidden="true"
      className={[
        "pointer-events-none absolute inset-0 overflow-hidden motion-safe:animate-[nojoGlint_120s_linear_infinite] motion-reduce:hidden",
        className,
      ].join(" ")}
    >
      <span
        className="absolute -top-1/2 h-[200%] block"
        style={{
          left: "-40%",
          width: `${w}px`,
          background:
            "linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.55) 50%, rgba(255,255,255,0) 100%)",
          transform: "skewX(-18deg)",
          // The actual sweep keyframes — runs as a quick double-pass at
          // the START of every 120s cycle, then idles.
          animation: "nojoGlintSweep 120s ease-in-out infinite",
          willChange: "transform, opacity",
        }}
      />
    </span>
  );
}
